import restClient from './restClient';
import { apiMap } from '../utilities';

const rxService = {
  getDiscountBanner: () => {
    return restClient.makeGetRequest(apiMap.getDiscountBanner());
  },

  getCartItems(body: any) {
    return restClient.makePostRequest(apiMap.getCartItems(), body);
  },

  checkVisitID: (visitID: string) => {
    return restClient.makeGetRequest(apiMap.checkVisitID(visitID));
  },
};

export default rxService;